import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';

export interface IAutoLoginUseCase {
    execute(
        username: string,
        identityToken: string,
        authSign: string,
        userLoginToken: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<any>;
}

export class AutoLoginUseCase implements IAutoLoginUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        identityToken: string,
        authSign: string,
        userLoginToken: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<any> {
        return await this.authRepo.autoLogin(
            username,
            identityToken,
            authSign,
            userLoginToken,
            apiToken,
            recaptchaToken
        );
    }
}
